module.exports = [{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-posthog@1.0.1_gatsby@5.15.0_react-dom@18.3.1_react@18.3.1/node_modules/gatsby-plugin-posthog/gatsby-browser.js'),
      options: {"plugins":[],"apiKey":"phc_PeAaQFWzsq9A4UKEgcvw7noru12R3xVLMtrdmBMcxni","apiHost":"https://eu.i.posthog.com","head":true,"isEnabledDevMode":true,"cookieless":true},
    },{
      plugin: require('../node_modules/.pnpm/gatsby@5.15.0_babel-eslint@10.1.0_react-dom@18.3.1_react@18.3.1_typescript@5.9.3/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
